import { FunctionComponent} from 'preact';

import CloseIcon from '@material-ui/icons/Close';
import shell from '../../../../../../public/img/yellow-shell.svg';

import styles from './styles.module.scss';

const GamesPromo: FunctionComponent<{
  animate: boolean;
  enabledCounter: number;
  hideGamesPopover: () => void;
}> = ({
  hideGamesPopover,
  animate,
  enabledCounter,
}: {
  hideGamesPopover: () => void;
  animate: false;
  enabledCounter;
}) => (
  <div
    className={`${styles.gamesPromo} ${animate ? '' : styles.noAnimation}`}
    style={enabledCounter === 2 ? {} : { width: 181 }}
  >
    {enabledCounter === 2 ? (
      <p>
        We added more games! Get shells{' '}
        <img src={shell} className={styles.shell} alt="shell" /> by playing
        them!
      </p>
    ) : (
      <p>
        Get shells <img src={shell} className={styles.shell} alt="shell" />
        <br /> by playing games!
      </p>
    )}

    <button type="button" onClick={hideGamesPopover}>
      <CloseIcon />
    </button>
  </div>
);

export default GamesPromo;
